import { useEffect } from 'react'
import { EnvConfig } from 'src/configurations'
import {
  setCspJwtCookie,
  setCspRefreshTokenCookie,
  setJwtCookie,
  setRefreshTokenCookie,
  setUserSessionTokenIdCookie,
} from 'src/cookies'
import { useAuthTokens } from 'src/hooks/useAuthTokens'

/**
 * Mirrors the session-token snapshot into its cookies on every token change, so a
 * reload rehydrates the session the SSR seed expects.
 */
export const useSyncTokenCookies = (envConfig: EnvConfig): void => {
  const { jwt, refreshToken, cspJwt, cspRefreshToken, userSessionTokenId } =
    useAuthTokens()

  useEffect((): void => {
    setJwtCookie(envConfig, jwt)
    setRefreshTokenCookie(envConfig, refreshToken)
    setCspJwtCookie(envConfig, cspJwt)
    setCspRefreshTokenCookie(envConfig, cspRefreshToken)
    setUserSessionTokenIdCookie(envConfig, userSessionTokenId)
    // tokens only — an envConfig identity change must not rewrite cookies
  }, [jwt, refreshToken, cspJwt, cspRefreshToken, userSessionTokenId])
}
